import type { ActivityCreationJourney } from '../../activity-creation/contracts';
import type { CreationDraft } from './creationInput';
import type { useCreationProviders } from './useCreationProviders';
import type { useCreationRepository } from './useCreationRepository';
import type { useCreationContent } from './useCreationContent';
import type { useCreationIssue } from './useCreationIssue';
import type { useCreationBoard } from './useCreationBoard';
import type { useCreationFeedback } from './useCreationFeedback';

export interface CreationForm {
  providers: ReturnType<typeof useCreationProviders>;
  repository: ReturnType<typeof useCreationRepository>;
  content: ReturnType<typeof useCreationContent>;
  issue: ReturnType<typeof useCreationIssue>;
  board: ReturnType<typeof useCreationBoard>;
  feedback: ReturnType<typeof useCreationFeedback>;
}

export function creationDraft(
  form: CreationForm,
  journey?: ActivityCreationJourney,
): CreationDraft {
  return {
    provider: form.providers.selected,
    repository: form.repository.value,
    hierarchy: form.issue.hierarchy,
    issue: form.issue.selected,
    workItem: form.board.selectedWorkItem,
    content: form.content.state,
    requireTargetBranch: journey?.requireTargetBranch ?? true,
    workPath: 'control-plane',
  };
}

export function resetCreationForm(form: CreationForm) {
  form.repository.reset();
  form.content.reset();
  form.feedback.reset();
  form.board.reset();
  form.issue.reset();
}
